import { provideRouter } from '@angular/router';
import { LabsRoutes } from './lab.routing';
import { MetaReducer, Action, provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { LabsState, LabsReducer } from './state/reducers/labs.reducer';
import { labsStateKey, uploadsStateKey, sequenceMetadataStateKey } from './state';
import { LabsEffects } from './state/effects/labs.effects';
import { UploadsEffects } from './state/effects/uploads.effects';
import { UploadsReducer } from './state/reducers/uploads.reducer';
import { SequenceMetadataEffects } from './state/effects/sequence-metadata.effects';
import { SequenceMetadataReducer } from './state/reducers/sequence-metadata.reducer';
import { createLocalStorageSyncReducer } from '../../shared/utils/local-storage-sync';

const localStorageSyncReducer = createLocalStorageSyncReducer<LabsState>([
  'labList',
  'getLabDetail',
  'getLabProjectUsersList',
  'selectedLab',
]);

const metaReducers: Array<MetaReducer<LabsState, Action>> = [localStorageSyncReducer];

export const labsConfig = [
  provideState(labsStateKey, LabsReducer, { metaReducers }),
  provideState(uploadsStateKey, UploadsReducer),
  provideState(sequenceMetadataStateKey, SequenceMetadataReducer),
  provideRouter(LabsRoutes),
  provideEffects([LabsEffects, UploadsEffects, SequenceMetadataEffects]),
  // Note: Services and facades with providedIn: 'root' don't need to be listed here
];
